"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MKFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_150)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_150`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24.0003H-6V0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.9912 23.9997L12 11.7389L13.8863 23.9997H20.9912ZM3.3913 -0.000244141L12 11.7389L10.194 -0.000244141H3.3913ZM10.1136 23.9997L12 11.7389L3.00873 23.9997H10.1136ZM-6 -0.000244141V8.96953L12 11.7389L-4.00783 -0.000244141H-6ZM-6 23.9997H-4.71947L12 11.7389L-6 14.5081V23.9997ZM12 11.7389L30 8.96953V-0.000244141H28.008L12 11.7389ZM13.8061 -0.000244141L12 11.7389L20.6087 -0.000244141H13.8061ZM30 23.9997V14.5081L12 11.7389L28.7194 23.9997H30Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 15.9128C14.305 15.9128 16.1737 14.0442 16.1737 11.7391C16.1737 9.43405 14.305 7.56543 12 7.56543C9.69492 7.56543 7.82629 9.43405 7.82629 11.7391C7.82629 14.0442 9.69492 15.9128 12 15.9128Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 14.8696C13.7289 14.8696 15.1304 13.468 15.1304 11.7391C15.1304 10.0102 13.7289 8.60864 12 8.60864C10.2711 8.60864 8.86951 10.0102 8.86951 11.7391C8.86951 13.468 10.2711 14.8696 12 14.8696Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_150`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MKFlag };
